// import { text } from "pdfkit";

const PRODUCT_GROUP = {
  PSC: "PSC",
  PDFAI: "PDFAI",
  FRX: "FRX",
  TKC: "TKC",
  NSTST: "NSTST",
  TST: "TST",
  APAUTO: "APAUTO",
  NS:"NS",
}


export default {
  namespaced: true,

  state: {
    userCompany:'',
    open: true,
    company: "",
    item: 1,
    itemsTKC: [
      {
        icon: "icon_invoice.svg",
        icon_active: "icon_invoice_white.svg",
        text: "เอกสารใบแจ้งหนี้",
        link: "Company.DocumentTOPSERV",
        group: PRODUCT_GROUP.TKC,
      },
    ],
    itemsExchangeRate: [
      {
        icon: "icon_money_exchange.svg",
        icon_active: "icon_money_exchange_white.svg",
        text: "อัตราแลกเปลี่ยน",
        link: "Company.ExchangeRate",
        group: PRODUCT_GROUP.FRX,
      },
      {
        icon: "icon_exchange_file.svg",
        icon_active: "icon_exchange_file_white.svg",
        text: "ประวัติอัตราแลกเปลี่ยน",
        link: "Company.ExchangeHistory",
        group: PRODUCT_GROUP.FRX,
      },
    ],
    itemsNsThaiSmartTax: [
      // Unified NS TST menu — one collapsible tree for ALL companies.
      // Previously this array carried two parallel copies: a flat
      // "default" set (disabled-header pattern, no chevron) gated by
      // `excludeCompanyIds`, and a tenant duplicate (isHeader + groupId
      // collapsible pattern) gated by `onlyCompanyIds`. The tenant
      // pattern is now the single source — every company gets the
      // chevron / expand-collapse experience.
      //
      // Product-flag gates still apply at the template level for
      // Company.TaxBuyAverage (isNsThaiSmartTaxAverage) and
      // Company.Documents.PND54 (isNsThaiSmartPnd54Pp36); routes that
      // used the old "Company.Documents.PP36" link now go through
      // "Company.Documents.PP36NTST" and are visible whenever the
      // company has NS TST at all.

      // === VAT ===
      {
        icon: "icon_menu_vat.svg",
        text: "ภาษีมูลค่าเพิ่ม",
        isHeader: true,
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },
      {
        text: "ภาษีขาย",
        link: "Company.TaxSales",
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },
      {
        text: "ภาษีซื้อ",
        link: "Company.TaxBuy",
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },
      {
        text: "ภาษีซื้อเฉลี่ย",
        link: "Company.TaxBuyAverage",
        group: PRODUCT_GROUP.NSTST,
        groupId: "vat",
      },
      {
        text: "รายงานภาษีมูลค่าเพิ่ม",
        link: "Company.taxSupplementaryReport",
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },
      {
        text: "แบบแสดงรายการภาษี",
        link: "Company.TaxReport",
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },
      {
        text: "ยกเลิกรายการ Vat",
        link: "Company.CancelValueAddedTax",
        group: PRODUCT_GROUP.TST,
        groupId: "vat",
      },

      // === WHT ===
      {
        icon: "icon_menu_withholdingTST.png",
        text: "ภาษีหัก ณ ที่จ่าย",
        isHeader: true,
        group: PRODUCT_GROUP.NSTST,
        groupId: "wht",
      },
      {
        text: "ภาษีหัก ณ ที่จ่าย",
        link: "Company.WithholdingTax",
        group: PRODUCT_GROUP.NSTST,
        groupId: "wht",
      },
      {
        text: "แบบยื่นรายการภาษี",
        link: "Company.WithholdingIncomTax",
        group: PRODUCT_GROUP.NSTST,
        groupId: "wht",
      },
      {
        text: "ยกเลิกรายการ WHT",
        link: "Company.WithholdingIncomTax.Cancel",
        group: PRODUCT_GROUP.NSTST,
        groupId: "wht",
      },

      // === PP.36 ===
      {
        icon: "icon_menu_pp36.svg",
        text: "ภ.พ.36",
        isHeader: true,
        group: PRODUCT_GROUP.NSTST,
        groupId: "pp36",
      },
      {
        text: "รายการ ภ.พ.36",
        link: "Company.Documents.PP36NTST",
        group: PRODUCT_GROUP.NSTST,
        groupId: "pp36",
      },
      {
        text: "รายงานภาษีมูลค่าเพิ่ม",
        link: "Company.TaxSupplementaryReportPP36",
        group: PRODUCT_GROUP.NSTST,
        groupId: "pp36",
      },
      {
        text: "ยกเลิกรายการ ภ.พ.36",
        link: "Company.CancelPP36NTST",
        group: PRODUCT_GROUP.NSTST,
        groupId: "pp36",
      },

      // === PND.54 ===
      {
        icon: "icon_menu_pnd54.svg",
        text: "ภ.ง.ด.54",
        isHeader: true,
        group: PRODUCT_GROUP.NSTST,
        groupId: "pnd54",
      },
      {
        text: "รายการ ภ.ง.ด.54",
        link: "Company.Documents.PND54",
        group: PRODUCT_GROUP.NSTST,
        groupId: "pnd54",
      },
      {
        text: "ยกเลิกรายการ ภ.ง.ด.54",
        link: "Company.CancelValueAddedTaxPP54",
        group: PRODUCT_GROUP.NSTST,
        groupId: "pnd54",
      },
    ],
    itemsNsFixedAsset: [
      // "Fixed Asset" is now a collapsible header — clicking the row
      // toggles the two children (List / Count). Same pattern as etax's
      // "เอกสารการขาย" refactor: the old landing link (Company.FixedAsset)
      // was a shell for the two sub-routes, so dropping it doesn't
      // remove any distinct destination.
      {
        icon: "icon_menu_poai.svg",
        icon_active: "icon_menu_poai_white.svg",
        text: "Fixed Asset",
        isHeader: true,
        groupId: "ns-fixed-asset",
        group: PRODUCT_GROUP.NS,
      },
      {
        text: "Fixed Assets List",
        link: "Company.FixedAssetsList",
        groupId: "ns-fixed-asset",
        group: PRODUCT_GROUP.NS,
      },
      {
        text: "Fixed Assets Count",
        link: "Company.FixedAssetCount",
        groupId: "ns-fixed-asset",
        group: PRODUCT_GROUP.NS,
      },
    ],
    itemsApAutomate: [
      {
        icon: "icon_menu_ap.svg",
        text: "AP Automate",
        isHeader: true,
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_upload.svg",
        icon_active: "icon_menu_ap_upload_white.svg",
        text: "Upload Doc",
        link: "Company.AccountsPayableUpload",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_vat.svg",
        icon_active: "icon_menu_ap_vat_white.svg",
        text: "VAT Monthly",
        link: "Company.AccountsPayable",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_vat_unclaim.svg",
        icon_active: "icon_menu_ap_vat_unclaim_white.svg",
        text: "VAT Unclaim",
        link: "Company.AccountsPayablePending",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_none_vat.svg",
        icon_active: "icon_menu_ap_none_vat_white.svg",
        text: "None VAT",
        link: "Company.AccountsPayableNoneVat",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_success.svg",
        icon_active: "icon_menu_ap_success_white.svg",
        text: "Success",
        link: "Company.AccountsPayableSuccess",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
      },
      {
        icon: "icon_menu_ap_reject.svg",
        icon_active: "icon_menu_ap_reject_white.svg",
        text: "Reject Document",
        link: "Company.AccountsPayableReject",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
        // onlyCompanyIds: ["FboSVOrTuPEyZUn1BzYI", "Qkr7IojjRBFEkBfIyZt4"],
      },
      {
        icon: "icon_menu_ap_auditReport.png",
        icon_active: "icon_menu_ap_auditReportWhite.png",
        text: "AuditAutomation",
        link: "Company.AccountsPayableAuditAutomation",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "ap-automate",
        onlyCompanyIds: ["1M5yrTyMtIlja9NT4G3h"],
      },

      {
        icon: "icon_menu_ap.svg",
        text: "Other Agencies",
        isHeader: true,
        group: PRODUCT_GROUP.APAUTO,
        groupId: "other-agencies",
      },
      {
        icon: "department-setting.svg",
        text: "Revenue Department",
        isHeader: true,
        group: PRODUCT_GROUP.APAUTO,
        groupId: "revenue-department",
        parentGroupId: "other-agencies",
        onlyCompanyIds: ["MI4TMErjpfZtKsyxtiNu"],
      },
      {
        icon: "icon_menu_ap_pnd123.svg",
        icon_active: "icon_menu_ap_pnd123_white.svg",
        text: "PND 1 2 3",
        link: "Company.AccountsPayablePND123",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "revenue-department",
        parentGroupId: "other-agencies",
        onlyCompanyIds: ["MI4TMErjpfZtKsyxtiNu"],
       },
      {
        icon: "icon_menu_ap_pnd50.svg",
        icon_active: "icon_menu_ap_pnd50_white.svg",
        text: "PND 50 51 52 53 54 55",
        link: "Company.AccountsPayablePND50to55",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "revenue-department",
        parentGroupId: "other-agencies",
        onlyCompanyIds: ["MI4TMErjpfZtKsyxtiNu"],
      },
      {
        icon: "icon_menu_ap_pp.svg",
        icon_active: "icon_menu_ap_pp_white.svg",
        text: "PP 30 36 40",
        link: "Company.AccountsPayableForeign",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "revenue-department",
        parentGroupId: "other-agencies",
      },
      {
        icon: "icon_menu_ap_success.svg",
        icon_active: "icon_menu_ap_success_white.svg",
        text: "Success",
        link: "Company.AccountsPayableForeignSuccess",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "revenue-department",
        parentGroupId: "other-agencies",
      },
    
      {
        icon: "icon_menu_report.svg",
        text: "Report",
        isHeader: true,
        group: PRODUCT_GROUP.APAUTO,
        groupId: "report",
      },
      {
        icon: "icon_menu_ap_analytics.svg",
        icon_active: "icon_menu_ap_analytics_white.svg",
        text: "Analytics",
        link: "Company.AccountsPayableAnalytics",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "report",
        onlydev: false
      },
      {
        icon: "icon_ap_tax_report.svg",
        icon_active: "icon_ap_tax_report_white.svg",
        text: "Journal Audit Report",
        link: "Company.AccountsPayableTaxReport",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "report",
      },
      {
        icon: "icon_menu_ap_loading_log.svg",
        icon_active: "icon_menu_ap_loading_log_white.svg",
        text: "Loading File Log",
        link: "Company.LoadingFileLog",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "report",
        // onlyCompanyIds: ["FboSVOrTuPEyZUn1BzYI", "Qkr7IojjRBFEkBfIyZt4"],
      },
      // {
      //   text: "Revenue Department",
      //   isHeader: true,
      //   group: PRODUCT_GROUP.APAUTO,
      //   groupId: "revenue-department",
      // },
      // {
      //   icon: "icon_menu_ap.svg",
      //   icon_active: "icon_menu_ap_white.svg",
      //   text: "PND 1-3",
      //   link: "Company.RevenueDepartmentPnd1to3",
      //   group: PRODUCT_GROUP.APAUTO,
      //   groupId: "revenue-department",
      // },
      // {
      //   icon: "icon_menu_ap.svg",
      //   icon_active: "icon_menu_ap_white.svg",
      //   text: "PND 50-55",
      //   link: "Company.RevenueDepartmentPnd50to55",
      //   group: PRODUCT_GROUP.APAUTO,
      //   groupId: "revenue-department",
      // },
      // {
      //   icon: "icon_menu_ap.svg",
      //   icon_active: "icon_menu_ap_white.svg",
      //   text: "PP 30 36 40",
      //   link: "Company.RevenueDepartmentPp303640",
      //   group: PRODUCT_GROUP.APAUTO,
      //   groupId: "revenue-department",
      // },
      // {
      //   icon: "icon_menu_ap.svg",
      //   icon_active: "icon_menu_ap_white.svg",
      //   text: "Success",
      //   link: "Company.RevenueDepartmentSuccess",
      //   group: PRODUCT_GROUP.APAUTO,
      //   groupId: "revenue-department",
      // }
    ],
    itemsApAutomateStudent : [
      {
        icon: "icon_menu_ap.svg",
        icon_active: "icon_menu_ap_white.svg",
        text: "AP Agent Lab",
        link: "Company.AccountsPayableStudent",
        group: PRODUCT_GROUP.APAUTO,
        // isOnlyAdmin: true,
        // onlydev: true 
      },
      {
        icon: "icon_menu_ap_report.svg",
        icon_active: "icon_menu_ap_report_white.svg",
        text: "Analytics",
        link: "Company.AccountsPayableAnalytics",
        group: PRODUCT_GROUP.APAUTO,
        onlydev: false 
      },
      // {
      //   icon: "icon_ap_tax_report.svg",
      //   icon_active: "icon_ap_tax_report_white.svg",
      //   text: "Journal Audit Report",
      //   link: "Company.AccountsPayableTaxReport",
      //   group: PRODUCT_GROUP.APAUTO,
      // },
        {
        icon: "icon_menu_setting.svg",
        icon_active: "icon_menu_setting_active_white.svg",
        text: "ตั้งค่า Prompt",
        link: "Company.Settings.ApAutomationPromptStudent",
        group: PRODUCT_GROUP.APAUTO,
        // isOnlyAdmin: true,
        // onlydev: true
        }
       ],

     itemsFileAutomate: [
      {
        icon: "icon_menu_ap.svg",
        text: "File Automate",
        isHeader: true,
        group: PRODUCT_GROUP.APAUTO,
        groupId: "file-automate",
        onlyCompanyIds: ["ykS6XoISZIaaVt9k9wB7"],
      },
      {
        icon: "icon_menu_ap.svg",
        icon_active: "icon_menu_ap_white.svg",
        text: "List File",
        link: "Company.AccountsPayableFileAuto",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "file-automate",
        onlyCompanyIds: ["ykS6XoISZIaaVt9k9wB7"],
      },
      {
        icon: "icon_menu_ap_report.svg",
        icon_active: "icon_menu_ap_report_white.svg",
        text: "Analytics",
        link: "Company.AccountsPayableAnalytics",
        group: PRODUCT_GROUP.APAUTO,
        groupId: "file-automate",
        onlyCompanyIds: ["ykS6XoISZIaaVt9k9wB7"],
        onlydev: false 
      },
     ],
       //: [
      //   {
      //   icon: "icon_menu_ap.svg",
      //   icon_active: "icon_menu_ap_white.svg",
      //   text: "AP Agent Lab",
      //   link: "Company.AccountsPayableStudent",
      //   group: PRODUCT_GROUP.APAUTO,
      // },
      // ],
    itemsSetting:   {
      icon: "icon_menu_setting.svg",
      icon_active: "icon_menu_setting_active_white.svg",
      text: "ตั้งค่า",
      link: "Company.Settings",
    },
    itemLoading: true,
    itemsPSC: [
        {
        icon: "icon_menu_dashboard.svg",
        icon_active: "icon_menu_dashboard_active_white.svg",
        text: "หน้าสรุป",
        link: "Company.Dashboard",
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_ecommerce.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "ใบสั่งขายออนไลน์",
        link: "Company.DocumentsSaleOnline",
        subLinks: [],
        group: PRODUCT_GROUP.PSC,
      },
      // "เอกสารการขาย" is now a collapsible header. Clicking the row
      // toggles the group; the 7 document-type leaves below carry the
      // same `groupId` so they show/hide together. The old Company.Documents
      // route entry point was removed from the menu — no page under it
      // renders anything the sub-items don't already reach.
      {
        icon: "icon_menu_tax.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "เอกสารการขาย",
        isHeader: true,
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      // "เอกสารทั้งหมด" restores the header's old landing link. When
      // "เอกสารการขาย" became a collapsible header it stopped navigating to
      // Company.Documents (the all-types list); this first child links there,
      // while the leaves below filter by a single document type.
      {
        text: "เอกสารทั้งหมด",
        link: "Company.Documents",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบกำกับภาษีเต็มรูป",
        link: "Company.Documents.TX",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบเพิ่มหนี้",
        link: "Company.Documents.DR",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบลดหนี้",
        link: "Company.Documents.CR",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบรับ",
        link: "Company.Documents.RE",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบกำกับภาษีอย่างย่อ",
        link: "Company.Documents.AB",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
        link: "Company.Documents.RT",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      {
        text: "ใบแจ้งยกเลิก",
        link: "Company.Documents.CL",
        groupId: "etax-docs-sale",
        group: PRODUCT_GROUP.PSC,
      },
      // Lao TaxRIS only — navigation-drawer.vue drops it for everyone else.
      {
        icon: "icon_menu_ap_success.svg",
        icon_active: "icon_menu_ap_success_white.svg",
        text: "ใบกำกับภาษีที่อนุมัติแล้ว",
        link: "Company.DocumentsApproved",
        requiresLaoTaxRis: true,
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_purchase_order.svg",
        icon_active: "icon_menu_tax_active_white.svg",
        text: "เอกสารการซื้อ",
        link: "Company.DocumentsPurchase",
        subLinks: [],
        group: PRODUCT_GROUP.PSC,
      },
      {
        icon: "icon_menu_report.svg",
        icon_active: "icon_menu_report_active_white.svg",
        text: "รายงาน",
        link: "Company.Report",
        group: PRODUCT_GROUP.PSC,
      },
    ],
    itemsVendor: [
      {
        icon: "icon_menu_report.svg",
        icon_active: "icon_menu_report_active_white.svg",
        text: "File Tracking",
        link: "Company.FileTracking",
        group: PRODUCT_GROUP.PDFAI,
        onlyCompanyIds: ["C39ABof74DqXVZmzaRfo", 'tcjwmtfcrh9FhBwnFWw7', 'uldQgcX8wiQFDNiKAlnb'], // Only show for specific companies
      },
      {
        icon: "icon_menu_dashboard.svg",
        icon_active: "icon_menu_dashboard_active_white.svg",
        text: "Report PO / SO",
        link: "Company.reportDocumentAI",
        group: PRODUCT_GROUP.PDFAI,
      },
      {
        icon: "icon_menu_poai.svg",
        icon_active: "icon_menu_poai_white.svg",
        text: "Customer PO",
        link: "Company.DocumentPOAI",
        group: PRODUCT_GROUP.PDFAI,
      },
      {
        link: "Company.DocumentSOAI",
        icon: "icon_menu_soai.svg",
        icon_active: "icon_menu_soai_white.svg",
        text: "Sale Order",
        group: PRODUCT_GROUP.PDFAI
      }
    ],
    vendorPOList: [
    ],
    vendorSOList: [
    ],
    isItemLoading: true,
    vendorListMerged: false,
    profileMenuToggle: false,
  },

  //   computed: {
  //   ...mapState({
  //     userCompany: (state) => state.user.userCompany,
  //   }),
    
  //   isCompanyAdmin() {
  //     return this.userCompany && this.userCompany.isAdmin;
  //   },
  // },
  
  mutations: {
    setDrawer(state) {
      state.open = !state.open;
    },
    setProfileMenu(state) {
      state.profileMenuToggle = !state.profileMenuToggle;
    },
    setVendorPOList(state, newValue) {
      // Check if newValue is an object or an array (assuming vendorPOList expects an object or array)
      if (Array.isArray(newValue)) {
        state.vendorPOList = newValue;
      } else {
        console.error("Invalid newValue type. Expected array.");
      }
    },
    setVendorSOList(state, newValue) {
      // Check if newValue is an object or an array (assuming vendorPOList expects an object or array)
      if (Array.isArray(newValue)) {
        state.vendorSOList = newValue;
      } else {
        console.error("Invalid newValue type. Expected array.");
      }
    },
    mergeVendorList(state) {
      // Remove any existing vendor lists to avoid duplicates
      state.itemsVendor = state.itemsVendor.filter(item => item.link !== "Company.DocumentPOAIVendor" && item.link !== "Company.DocumentSOAIVendor");

      const documentPOAIIndex = state.itemsVendor.findIndex(item => item.link === "Company.DocumentPOAI");

      // Insert vendorPOList after the second to last item if POAI is found
      if (documentPOAIIndex !== -1) {
        const insertionIndexPO = state.itemsVendor.length - 1;
        state.itemsVendor.splice(insertionIndexPO, 0, ...state.vendorPOList);
      }

      // Recalculate documentSOAIIndex since the array might have changed
      const newDocumentSOAIIndex = state.itemsVendor.findIndex(item => item.link === "Company.DocumentSOAI");

      // Insert vendorSOList after the new documentSOAIIndex
      if (newDocumentSOAIIndex !== -1) {
        const insertionIndexSO = newDocumentSOAIIndex + 1;
        state.itemsVendor.splice(insertionIndexSO, 0, ...state.vendorSOList);
      }
      state.isItemLoading = false;
    },
    setVendorListMerged(state) {
      state.vendorListMerged = true; // Set the flag to true
    },
    setIsItemLoading(state, payload) {
      state.isItemLoading = payload.newValue;
    },
    setitemsTKC(state, newValue) {
      if (Array.isArray(newValue)) {
        state.itemsTKC = [state.itemsTKC[0], ...newValue];
      }
    },
    setUserCompany(state, userCompany) {
      state.userCompany = userCompany;
    },
  },
  actions: {
    toggle({ commit }) {
      commit("setDrawer");
    },
    toggleProfileMenu({ commit }) {
      commit("setProfileMenu");
    },
    setIsItemLoading({ commit }, payload) {
      console.log("Hello from setIsItemLoading action", payload)
      commit("setIsItemLoading", payload);
    },
    // fetchUserCompany({ commit }) {
    //   // ดึงข้อมูล userCompany จาก API หรือที่อื่นๆ
    //   api.fetchUserCompany()
    //     .then(response => {
    //       commit('setUserCompany', response.data);
    //     })
    //     .catch(error => {
    //       console.error("ไม่สามารถดึงข้อมูล userCompany ได้", error);
    //     });
    // },
  },
   
  modules: {}
};
